import {useRouteError} from "react-router-dom";

//IMG
import errorimg from "assets/img/commons/error.webp"

//CSS
import styles from "./error.module.less"

const ErrorPage = () => {
    const error = useRouteError();
    //console.error(error.statusText || error.message);
    console.error(error.cause && '[E'+ error.cause+']');

    return (
      <div className={styles.errorpage}>
          <img src={errorimg} alt="Imagen error page"/>
      </div>
    );
}

export default ErrorPage;
